<div *ngIf="!!tabsSearchSet" class="tabs-search-wrapper d-flex">
  <flo-search-input-next-gen (search)="handleSearch($event)" class="search-min-width" [searchModel]="tabsSearchSet.search"></flo-search-input-next-gen>
  <flo-tabs [tabsModel]="tabsSearchSet.tabs"></flo-tabs>
</div>
